import { Fade, Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Config from '../../services/config';
import CustomModal from '../CustomModal/CustomModal';
import Datagrid from '../Datagrid/Datagrid';
import { DataViewContext } from '../DataViewProvider/DataViewProvider';
import DocumentPreviewer from '../DocumentPreviewer/DocumentPreviewer';
import { getResourceColumns } from './ResourceColumns';
import styles from './ResourcesList.module.scss';

export default function ResourcesList() {
    const context = useContext(DataViewContext)

    const nodes = context?.data?.resources?.nodes
    const rows = nodes || []

    const [previewRow, setPreviewRow] = useState<any | null>(null)

    const resourceColumns = getResourceColumns({ setPreviewRow })

    useEffect(() => {
        context.setView("resourcesView")
        context.setColumnDefs(resourceColumns)
    }, [])

    return (
        <Fade in={!context.loading} timeout={Config.DEFAULT_FADE_TIMEOUT}>
            <div className={styles.ResourcesList}>
                <Datagrid
                    rows={rows}
                    columns={context?.columns}
                    loading={context.loading}
                    totalCount={context?.totalCount}
                    paginationModel={context?.paginationModel}
                    setPaginationModel={context?.setPaginationModel}
                    setSortModel={context?.setSortModel}
                    setColumnOrderModel={context?.setColumnOrderModel}
                    columnVisibilityModel={context?.columnVisibilityModel}
                    setColumnVisibilityModel={context?.setColumnVisibilityModel}
                    onRowSelectionModelChange={context?.setRowSelectionModel}
                    rowSelectionModel={context?.rowSelectionModel}
                    disableSelectionOnClick={true}
                />
                <CustomModal isActive={!!previewRow} handleClose={() => setPreviewRow(null)} fullScreen={true} backgroundColor="gray" textColor="white">
                    <Grid container justifyContent="center">
                        <DocumentPreviewer file={previewRow?.path} mimeType={previewRow?.fileType?.mimeType} />
                    </Grid>
                </CustomModal>
            </div>
        </Fade>
    );
}

